<div class="floating-menu" [ngStyle]="{'left': buttonLeftPosition}">
  <ng-container *ngIf="actionsMenuState.isLoading">
  <div class="loading-block">
    <span>We're processing your request. Please hang tight.</span>

    <ng-lottie [options]="lottieOptions" width="15px" height="15px"></ng-lottie>
  </div>
  </ng-container>

  <ng-container *ngIf="!actionsMenuState.isLoading">
    <span class="selected-items">{{actionsMenuState.selectedCompetitors?.length}} items selected</span>

    <div class="actions-wrapper">
      <button *ngIf="hasAnyNotActiveCompetitor" mat-button class="action-item" (click)="emitAction(FloatingMenuActionsEnum.ACTIVATE_COMPETITORS)">
        <img src="assets/images/icons/activate_gray.svg" alt="Activate">

        Activate selection
      </button>

      <button *ngIf="hasAnyActiveCompetitor" mat-button class="action-item" (click)="emitAction(FloatingMenuActionsEnum.DEACTIVATE_COMPETITORS)">
        <img src="assets/images/icons/circle-block_gray.svg" alt="Deactivate">

        Deactivate selection
      </button>
    </div>

    <button *ngIf="!actionsMenuState?.isAllItemsSelected"
            mat-button class="action-item p-0"
            (click)="emitAction(FloatingMenuActionsEnum.SELECT_ALL_COMPETITORS)">
      Select all {{actionsMenuState?.allItemsAmount}} items
    </button>

    <button *ngIf="actionsMenuState?.isAllItemsSelected"
            mat-button class="action-item p-0"
            (click)="emitAction(FloatingMenuActionsEnum.UNSELECT_ALL_COMPETITORS)">
      Unselect all {{actionsMenuState?.allItemsAmount}} items
    </button>
  </ng-container>
</div>
